/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForResourceActivityLogSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForResourceActivityLogSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForResourceActivityLogSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForResourceActivityLogSync>): BackgroundJobPayloadForResourceActivityLogSync {
        let obj = Object.assign(new BackgroundJobPayloadForResourceActivityLogSync(), model);
        BackgroundJobPayloadForResourceActivityLogSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForResourceActivityLogSync>): BackgroundJobPayloadForResourceActivityLogSync {
        if (!model) return null;
        return BackgroundJobPayloadForResourceActivityLogSync.newInstance(<BackgroundJobPayloadForResourceActivityLogSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForResourceActivityLogSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForResourceActivityLogSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForResourceActivityLogSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForResourceActivityLogSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

    operation_id: string;

    resource_filter: string;

    meta_data: { [key: string]: string; };

    service_name: string;

    user_name: string;

}
